import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { pageKeyForRoute } from '@/lib/pagePermissionMap';

/**
 * 현재 라우트 페이지의 수정 권한(canModify) 기반 액션 버튼 숨김 판정.
 *
 * - hideActions: 이 페이지에 canModify 가 없으면(=읽기전용) 액션 CTA 를 숨긴다.
 *   super admin·미매핑(신규) 페이지·canModify=true 인 역할은 숨기지 않는다.
 * - readOnly: 편의 별칭(= !canModify).
 *
 * 역할 하드코딩 없이 role_page_permissions(=/permissions UI 설정)로 구동된다.
 */
export function useReadonly() {
  const auth = useAuthStore();
  const route = useRoute();
  const canModify = computed(() => auth.canModifyPage(pageKeyForRoute(route.path)));
  const hideActions = computed(() => !canModify.value);
  return { readOnly: computed(() => !canModify.value), hideActions };
}
